<template>
  <div class="nx-filters">
    <v-toolbar v-if="label" class="nx-filters-toolbar nx-heading--level-1 pt-1" color="transparent" flat>
      <v-toolbar-title>{{ label }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-expansion-panel
      :key="`${scope}-filters`"
      v-model="expandedPanels"
      expand>
      <v-expansion-panel-content
        v-for="(item) in computedFilters"
        :key="`${scope}-${item.filter}`">
        <div
          class="subheading"
          slot="header"
          v-html="$tc(`message.searcher.filters.${item.filter}`)">
        </div>
        <component
          :filter="item.filter"
          :is="item.component"
          :disabled="item.disabled"
          :value="value[item.filter]"
          @input="updateFilter"
          class="pl-4"
          v-bind="item.params">
        </component>
        <v-checkbox v-if="item.params.includeDescendants"
                    class="my-0 py-0 pl-4"
                    :input-value="value[`${item.filter}IncludeDescendants`]"
                    @change="updateFilter(`${item.filter}IncludeDescendants`, $event)"
                    :label="$t('message.searcher.filters.includeDescendants')"></v-checkbox>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { filters } from './config';
import { modifiedProperties } from '@/utils';

export default {
  name: 'nx-filters',
  props: {
    label: {
      type: String,
    },
    scope: {
      type: String,
      default: 'filters-scope',
    },
    filters: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabledFilters: {
      type: Array,
      default: () => ([]),
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    expandedPanels: [],
  }),
  computed: {
    computedFilters() {
      const computedFilters = [];
      this.filters.forEach((filter) => {
        const component = filters[filter.component];
        if (!component) {
          console.error(`Invalid filter component ${filter.component} for filter ${filter.name}.`);
        } else {
          let disabled = false;
          if (this.disabledFilters.indexOf(filter.filter) !== -1) {
            disabled = true;
          }
          computedFilters.push({ ...filter, component, disabled });
        }
      });
      return computedFilters;
    },
  },
  methods: {
    updateFilter(filter, value, silent = false) {
      const state = cloneDeep(this.value);
      if (value === null
        || (Array.isArray(value) && value.length === 0)) {
        delete state[filter];
      } else {
        state[filter] = value;
      }
      this.$emit('input', state, silent);
    },
  },
  watch: {
    value(newValue, oldValue) {
      const diff = modifiedProperties(newValue, oldValue);
      const expandedIndexes = diff.map(filter => this.computedFilters.findIndex(item => filter === item.filter));
      // Expand the panel on new external values in the same searcher (example: silent default values)
      expandedIndexes
        .filter(index => index >= 0)
        .forEach(index => this.$set(this.expandedPanels, index, true));
    },
    computedFilters: {
      handler(value) {
        this.expandedPanels = value.map(item => typeof this.value[item.filter] !== 'undefined');
      },
      immediate: true,
    },
  },
};
</script>

<style lang="stylus">
.nx-filters {
  overflow: hidden;
  position: relative;

  .v-expansion-panel {
    box-shadow: none
  }
  .subheading {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .v-autocomplete {
    .v-select__selections {
      max-width: calc(100% - 40px);
      .v-chip {
        max-width: 100%;
      }
      .v-chip__content {
        max-width: 100%;
      }
      .v-chip__close {
        flex: 0 0 auto;
      }
    }
  }
}

.theme--light .v-expansion-panel .v-expansion-panel__container,
.application .theme--light.v-expansion-panel .v-expansion-panel__container {
  background-color: transparent; // nx-primary--lighten-5
  border-top-color: transparent;
}
</style>
